export default "__VITE_ASSET__24dbcdb9__"